<template>
  <property-list :value="propertyList" />
</template>

<script>
import PropertyList from '@/app/components/PropertyList';
import { getLanguageName } from '@/app/library/languageSelector';

export default {
  name: 'EmailNotificationsSettingsPropertyList',
  components: {
    PropertyList
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    propertyList() {
      return [
        {
          name: this.$t('consumer-profile.email-notifications.language'),
          value: getLanguageName(this.value.language)
        },
        {
          name: this.$t('consumer-profile.email-notifications.support'),
          value: this.value.support ? this.$t('consumer-profile.email-notifications.ticket-status') : this.$t('consumer-profile.email-notifications.none')
        },
        {
          name: this.$t('consumer-profile.email-notifications.marketing'),
          value: this.value.home ? this.$t('consumer-profile.email-notifications.home-offers') : this.$t('consumer-profile.email-notifications.none')
        }
      ];
    }
  }
};
</script>
